import { render, staticRenderFns } from "./ReceiptShareDialog.vue?vue&type=template&id=4f40e24c&scoped=true"
import script from "./ReceiptShareDialog.vue?vue&type=script&lang=js"
export * from "./ReceiptShareDialog.vue?vue&type=script&lang=js"
import style0 from "./ReceiptShareDialog.vue?vue&type=style&index=0&id=4f40e24c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f40e24c",
  null
  
)

export default component.exports